import { GetThunkAPI } from '@reduxjs/toolkit/dist/createAsyncThunk';
import RequestService, {
    RequestServiceResponse,
} from '@tcc-online/request-service';
import UserSlice from '../slices/UserSlice';
import UserInfo from '../types/UserInfo';
import { NotificationActions } from '../actions/NotificationActions';

const ENDPOINT = '/participant';

const UserService = {
    getActiveQuestionnaires,
    getInfo,
};

async function getActiveQuestionnaires(
    _: undefined,
    thunk: GetThunkAPI<any>,
): Promise<RequestServiceResponse<any[]> | undefined> {
    const { requestId } = UserSlice.state.activeQuestionnaires(
        thunk.getState(),
    );
    if (requestId !== thunk.requestId) {
        return;
    }

    return await RequestService.get<any[]>(`${ENDPOINT}/active-questionnaires`);
}

async function getInfo(payload: { authToken: string }, api: GetThunkAPI<any>) {
    try {
        const { requestId } = UserSlice.state.info(api.getState());
        if (requestId !== api.requestId) {
            return null;
        }

        return await RequestService.get<UserInfo>(
            '/user-info',
            {},
            { headers: { Authorization: `Bearer ${payload.authToken}` } },
        );
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (e) {
        api.dispatch(
            NotificationActions.error('Nepodařilo se načíst info uživatele'),
        ); // TODO: translate
    }
}

export default UserService;
